<script setup>
import { tv } from 'tailwind-variants';

/**
 * @typedef {object} SpinnerProps
 * @property {('xs'|'sm'|'md')} [size='sm'] - Size of the spinner
 */

/**
 * @type {SpinnerProps}
 */
const props = defineProps({
  size: {
    type: String,
    default: 'sm',
  },
});

const spinner = tv({
  base: 'animate-spin ',
  variants: {
    size: {
      xs: 'h-4 w-4',
      sm: 'h-5 w-5',
      md: 'h-8 w-8',
    },
  },
});
</script>

<template>
  <svg :class="spinner({ size: props.size })" viewBox="0 0 20 20">
    <path
      d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z"
      fill="currentColor"
    />
  </svg>
</template>
